import { COLORS } from '@/styles/colors';
import { ellipsis } from '@/styles/common';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { body, bodySmall, poppinsMediumFont, subTitle } from '@/styles/typography';
import styled from 'styled-components';

export const PrimaryDetailsPanelWrapper = styled.div<{ backgroundColor?: string }>`
  ${flex({ flexDirection: 'column' })};
  padding: 24px;
  border-radius: 16px;
  background: ${({ backgroundColor }) => backgroundColor || COLORS.blue[200]};
  box-shadow: 0 4px 12px 0 rgb(0 39 32 / 15%);
  gap: 24px;
  border: 1px solid ${COLORS.grey[350]};
`;

export const PrimaryDetailsPanelHeading = styled.div`
  ${flex({ justifyContent: 'space-between' })};
  column-gap: 5%;
`;

export const PrimaryDetailsPanelContent = styled.div<{ width?: string }>`
  ${flex({ justifyContent: 'space-between', alignItems: 'center' })};
  gap: 30px;
  width: 80%;
  ${({ width }) => width && `width: ${width};`};

  ${media.tablet`
    width: 100%;
  `}

  ${media.mobile`
    width: 100%;
    ${flex({ alignItems: 'stretch', flexDirection: 'column' })};
    gap: 6px;
  `}
`;

export const PrimaryDetailsPanelHeader = styled.div`
  ${poppinsMediumFont};
  ${subTitle};
  ${ellipsis};
  color: ${COLORS.grey[950]};
  width: 90%;
  white-space: pre-wrap;
`;

export const PrimaryDetailsPanelColumnWrapper = styled.div<{ ratio?: string }>`
  ${flex({ flexDirection: 'column' })};

  ${({ ratio }) => ratio && `flex: ${ratio};`};

  ${media.mobile`
    width: 100%;
    ${flex({ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' })};
  `}
`;

export const PrimaryDetailsPanelColumnTitle = styled.div`
  ${bodySmall};
  color: ${COLORS.grey[600]};
  margin-bottom: 8px;

  ${media.mobile`
    margin-bottom: 0;
  `}
`;

export const PrimaryDetailsPanelColumnValue = styled.div`
  ${poppinsMediumFont};
  ${body};
  color: ${COLORS.black};

  ${media.mobile`
    ${ellipsis};  
  `}
`;
